var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Modals } from './Modals';
import { DatePicker } from './DatePicker';
export class MemberArea extends Component {
    constructor(isDebugEnabled = false) {
        super('MemberArea', false);
        this.haveListsBeenModified = false;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('header').hasClass('header-member-area')) {
                // Prevent navigation to other tab if form has unsave changes
                $('.prevents-navigation input, select, textarea').on('change', (event, formElement) => {
                    formElement.parents('form').addClass('has-changes');
                });
                $('.prevents-navigation').on('submit', (event, form) => {
                    form.addClass('is-submitting');
                });
                $(window).on('beforeunload', (event) => {
                    if (!$('.prevents-navigation').hasClass('is-submitting') && ($('.prevents-navigation.has-changes').length > 0 || this.haveListsBeenModified))
                        event.preventDefault();
                });
                // Duplicate element
                $('.btn-duplicate-list-item').on('click', (event, button) => {
                    event.preventDefault();
                    const list = $(button.attr('href'));
                    const duplicatedElement = list.find('.related-set-list-item').last().clone();
                    const originalIndex = duplicatedElement.data('index');
                    const index = new Date().getTime();
                    duplicatedElement.data('index', index);
                    duplicatedElement.find('input, select, textarea').each((formElement) => {
                        if (formElement.attr('type') != 'checkbox')
                            formElement.val('');
                        formElement.removeAttr('checked');
                        formElement.removeClass('disabled');
                        formElement.attr('name', formElement.attr('name').replace('/' + originalIndex + '/', '/' + index + '/'));
                        if (formElement.hasClass('date-picker'))
                            DatePicker.init(formElement);
                        if (formElement.attr('name').includes('SPE_tournee_TOU::isPublie'))
                            formElement.attr('checked', 'checked').next().removeClass('disabled');
                    });
                    duplicatedElement.find('[name="relatedSet/SPE_tournee_TOU/' + index + '/SPE_tournee_TOU::isCreation"]').addClass('disabled');
                    duplicatedElement.find('[name="relatedSet/SPE_tournee_TOU/' + index + '/SPE_tournee_TOU::isPostponed"]').removeClass('disabled');
                    duplicatedElement.find('[name="relatedSet/SPE_tournee_TOU/' + index + '/SPE_tournee_TOU::isPostponed"] + label').removeClass('disabled');
                    duplicatedElement.find('.btn-remove-parent').removeClass('d-none');
                    duplicatedElement.find('.remove-when-duplicated').remove();
                    duplicatedElement.find('.warning-existing').remove();
                    if (list.data('addBefore') == 'true') {
                        list.prepend(duplicatedElement);
                        $.scrollTo(0);
                    }
                    else {
                        list.append(duplicatedElement);
                    }
                    this.haveListsBeenModified = true;
                });
                // Remove element
                $('body').on('click', '.btn-remove-parent', (event, button) => {
                    event.preventDefault();
                    const list = button.parents('.related-set-list');
                    const min = parseInt(list.data('min'));
                    if (min != 0 && min == list.find('.related-set-list-item').length) {
                        alert('Cette liste doit comporter au minimum ' + min + ' élément(s).');
                        return;
                    }
                    if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?'))
                        button.parents('.related-set-list-item').remove();
                    if (list.find('.related-set-list-item').length === 0) {
                        list.find('.text-danger').removeClass('d-none');
                    }
                    else {
                        list.find('.text-danger').addClass('d-none');
                    }
                    this.haveListsBeenModified = true;
                });
                // Ajax search in filemaker
                $('.search-query').on('keyup', (event, input) => {
                    if (['Enter', 'NumpadEnter'].includes(event.code)) {
                        $('.btn-fm-search').trigger('click');
                    }
                });
                $('.btn-fm-search').on('click', (event, button) => __awaiter(this, void 0, void 0, function* () {
                    const parent = button.parents('.modal');
                    const query = parent.find('.search-query').val();
                    if (query.length === 0) {
                        $('.search-query').get(0).focus();
                        return;
                    }
                    ;
                    $('.search-no-results, .search-not-in-result').addClass('d-none');
                    $('.search-results').addClass('d-none').find('tbody').empty();
                    parent.find('.search-show-after').addClass('d-none');
                    parent.find('.btn-fm-search, .search-query').attr('disabled', 'disabled');
                    parent.find('.search-loading').removeClass('d-none');
                    const response = yield $.httpRequest({
                        url: '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        body: {
                            'action': 'get_fm_content',
                            'model': parent.data('model'),
                            'query[text]': query,
                            'data-type': 'json'
                        },
                        dataType: 'json'
                    });
                    this.displayResults(parent, response, parent.data('model'));
                    parent.find('.search-show-after').removeClass('d-none');
                    parent.find('.btn-fm-search, .search-query').removeAttr('disabled');
                    parent.find('.search-loading').addClass('d-none');
                }));
                // Add member to structure
                $('body').on('click', '.btn-add-member-to-structure', (event, button) => {
                    event.preventDefault();
                    const details = JSON.parse(atob(button.parents('tr').data('details')));
                    this.addMemberToList(button.attr('href'), details);
                    Modals.closeAllModals();
                });
                // Add new member to structure
                $('body').on('submit', '.form-create-member', (event, form) => {
                    event.preventDefault();
                    const details = Object.fromEntries(new FormData(form.get(0)));
                    this.addMemberToList(form.data('target'), details);
                    Modals.closeAllModals();
                });
                // Add place to tour
                $('body').on('click', '.btn-add-place-to-tour', (event, button) => {
                    event.preventDefault();
                    const details = JSON.parse(atob(button.parents('tr').data('details')));
                    this.addPlaceToField(button.parents('.modal').data('targetField'), details);
                    Modals.closeAllModals();
                });
                // Add new place to tour
                $('.btn-show-modal[href="#modal-create-place"]').on('click', (event, button) => {
                    $('#modal-create-place').data('targetField', button.parents('.modal').data('targetField'));
                });
                $('.form-create-place').on('submit', (event, form) => __awaiter(this, void 0, void 0, function* () {
                    event.preventDefault();
                    $('.form-nodification').addClass('d-none');
                    form.find('.btn-primary').addClass('is-loading');
                    const body = Object.fromEntries(new FormData(form.get(0)));
                    const response = yield $.httpRequest({
                        url: '/wp-admin/admin-ajax.php',
                        type: 'POST',
                        body: Object.assign(Object.assign({}, body), { 'action': 'create_structure' }),
                        dataType: 'json'
                    });
                    form.find('.btn-primary').removeClass('is-loading');
                    if (response.success) {
                        this.addPlaceToField(form.parents('.modal').data('targetField'), response);
                        Modals.closeAllModals();
                    }
                    else {
                        $('.form-nodification').removeClass('d-none').html(response.error);
                    }
                }));
                // Force search
                $('body').on('keydown', '.force-search', (event, button) => {
                    event.preventDefault();
                });
                // Force search place
                $('body').on('click', '.force-search:not(.date-picker)', (event, formElement) => {
                    event.preventDefault();
                    const target = $('#' + formElement.data('searchTarget'));
                    target.data('targetField', formElement.attr('name'));
                    Modals.open(target);
                });
                // Max length
                $('.form-controll-length-counter').each((lengthController) => {
                    const parent = lengthController.parents('.form-control-row');
                    parent.find('input, textarea').on('keyup', (event, formElement) => {
                        lengthController.find('span').text(formElement.val().length);
                    });
                    lengthController.find('span').text(parent.find('input, textarea').val().length);
                });
                $('.form-main:not(.needs-validation)').on('submit', (event, form) => {
                    form.find('.btn-primary').addClass('is-loading');
                });
            }
            this.success();
        });
    }
    displayResults(parent, response, model) {
        if (response.count === 0) {
            parent.find('.search-no-results').removeClass('d-none');
        }
        else {
            const container = parent.find('.search-results tbody');
            let tableHTML = '';
            response.results.forEach((result) => {
                const details = btoa(JSON.stringify(result));
                if (model == 'people')
                    tableHTML += `<tr data-details="${details}"><td>${result.prenom} ${result.nom} (${result.email})</td><td class="text-end"><a class="btn-add-member-to-structure btn btn-outline-primary btn-sm" href="#structure-members-list">Sélectionner</a></td></tr>`;
                if (model == 'place')
                    tableHTML += `<tr data-details="${details}"><td>${result.title}<br><small>${result.place}</small></td><td class="text-end" valign="middle"><a class="btn-add-place-to-tour btn btn-outline-primary btn-sm" href="#">Sélectionner</a></td></tr>`;
            });
            container.html(tableHTML);
            parent.find('.search-results, .search-not-in-result').removeClass('d-none');
        }
    }
    addMemberToList(target, details) {
        let index = parseInt($(target).find('.member').last().data('index')) + 1;
        if (isNaN(index))
            index = 0;
        const newMember = $('#model-member').clone();
        newMember.removeAttr('id');
        newMember.attr('data-index', '' + index);
        console.log(index);
        newMember.find('input, select, textarea').each((formElement) => {
            formElement.attr('name', formElement.attr('name').replace('{INDEX}', index.toString()));
            formElement.attr('id', formElement.attr('id').replace('{INDEX}', index.toString()));
        });
        Object.entries(details).forEach(([key, value]) => {
            const formElement = newMember.find('[name$="::' + key + '"]');
            if (formElement.length > 0) {
                formElement.val(value);
            }
        });
        $(target).append(newMember);
        this.haveListsBeenModified = true;
    }
    addPlaceToField(target, details) {
        const targetElement = $('[name="' + target + '"]');
        targetElement.val(details.title);
        targetElement.parents('.form-control-row').prev().val(details.id);
        this.haveListsBeenModified = true;
    }
}
